import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  kaizenIdeaReplyId: string;
};

type MessageWithIdType = ResponseMessageType & {
  id: string;
};

const request = ({ kaizenIdeaReplyId }: RequestDataType) => {
  return new ApiClient()
    .post<MessageWithIdType>(
      `/api/members/kaizen_idea_replies/${kaizenIdeaReplyId}/likes`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersKaizenIdeaRepliesLikesCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<MessageWithIdType, RequestDataType> => {
  return useMutation(request, { ...options });
};
